

















































import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';
import { mapActions } from 'vuex';
import { Getter } from 'vuex-class';
import { closeManualVaccination } from '@/services/api/closeManual/api';
import { InfosPSBEN } from '@/store/infosPSBEN/types';
import { ParametresUtilisateur } from '@/store/parametresUtilisateur/types';
import { adapteFormVaccinateurPs } from '@/components/Vaccination/InformationsVaccin/adapter';

const Props = Vue.extend({
	props: {
		popinCloseCycle: {
			type: Boolean,
			required: true
		},
		numeroBon: {
			type: String,
			required : true
		}
	}
});

@Component({
	methods: {
		...mapActions('globalState', ['addLoading', 'removeLoading'])
	},
	model: {
		prop: 'popinCloseCycle',
		event: 'change'
	}
})
export default class PopInCloseVaccination extends Props {
	@Getter('infosPSBEN/getInfosPSBEN') infosPsben!: InfosPSBEN;
	@Getter('parametresUtilisateur/getParametresUtilisateur') parametresUtilisateur!: Map<string, ParametresUtilisateur>;

	errorCode = '';
	isError = false;

	cleanError() {
		this.errorCode = '';
		this.isError = false;
	}

	get hasErrorCode() {
		return !_.isNil(this.errorCode) && this.errorCode !== '';
	}

	get computedValue(): boolean {
		return this.popinCloseCycle;
	}

	set computedValue(value: boolean) {
		this.$emit('change', value);
	}

	closeVaccination() {
		this.cleanError();

		const numeroBon = this.numeroBon;
		const parametresUtilisateur =
			this.parametresUtilisateur.get(_.get(this.infosPsben, 'ps.numRPPS')) as ParametresUtilisateur;
		const psDelegation = _.get(parametresUtilisateur, 'delegation');
		const ps = this.parametresUtilisateur.get(_.get(this.infosPsben, 'ps.numRPPS'));

		const postInjectionCloseRequest = {
			numeroBon,
			close: true,
			ps : adapteFormVaccinateurPs(this.infosPsben, ps),
			psDelegation
		};
		this.addLoading();

		closeManualVaccination(postInjectionCloseRequest)
		.then((response) => {
			const errorCode = _.get(response, 'data.value.errorCode');
			if (_.isEmpty(errorCode)) {
				this.computedValue = false;
				this.$store.dispatch('infosVaccinationFolder/updateFolderAndFlags', response);
				this.$emit('closeFolder');
			} else {
				this.errorCode = errorCode;
				this.isError = true;
			}

			this.removeLoading();
		})
		.catch(() => {
			this.computedValue = false;
			this.removeLoading();
		});
	}
}
